import { Directive, input } from '@angular/core';

@Directive({
  selector: '[b2cScrollTo]',
  host: {
    '(click)': 'onClick()',
  },
})
export class ScrollToDirective {
  target = input<string>('');

  onClick() {
    const targetElement: Element = document.querySelector(
      this.target()
    ) as Element;
    targetElement?.scrollIntoView({ behavior: 'smooth' });
  }
}
